module.exports = __webpack_public_path__ + "assets/img/password_ico.9925d88a.png";